import AlertDialog from "./AlertDialog";

export default function ReportDialog({ close }: ModalComponentProps) {
  return (
    <AlertDialog close={close} title="신고 완료">
      <div className="px-[20px] pt-[16px] mt-[14px] text-left bg-[#f5f5f5] text-[#888] font-[500] text-[14px]">
        {`신고가 정상 접수되었습니다.
회원님께서 보내주신 신고 내용은 담당자가
꼼꼼히 확인하여 필요한 경우 신속하게 적절한
조치를 취할 예정입니다.
커뮤니티를 안전하고 쾌적하게 유지하기 위한
회원님의 협조에 깊이 감사드립니다.`}
      </div>
    </AlertDialog>
  );
}
